import React, { useState } from 'react';
import { Tag, Search } from 'lucide-react';
import { SeletorCidade } from './BuscaEndereco';
import { PlanosClaro } from './PlanosClaro';

// Planos e preços da Claro escolhendo só UF + cidade (sem CEP / HP)
export const PlanosPorCidade = ({ uf: ufInicial = '', cidade: cidadeInicial = '', tipoCliente = 'RESIDENCIAL', credito = null, escolherCredito = false, onEscolherPlano = null, compacto = false, testid = 'planos-cidade' }) => {
  const [uf, setUf] = useState(ufInicial);
  const [cidade, setCidade] = useState(cidadeInicial);
  const [alvo, setAlvo] = useState(ufInicial && cidadeInicial ? { uf: ufInicial, cidade: cidadeInicial } : null);
  const pronto = (uf || '').length === 2 && (cidade || '').trim().length >= 2;
  const ver = () => pronto && setAlvo({ uf, cidade: cidade.trim().toUpperCase() });
  return (
    <div className="space-y-3" data-testid={testid}>
      <div className="flex flex-wrap items-end gap-2">
        <div className="space-y-1">
          <p className="text-xs font-semibold text-gray-600 dark:text-gray-300 inline-flex items-center gap-1"><Tag className="w-3.5 h-3.5 text-purple-600" /> Escolha a cidade para ver os planos da Claro</p>
          <SeletorCidade uf={uf} cidade={cidade} onUf={setUf} onCidade={setCidade} testid={`${testid}-sel`} />
        </div>
        <button type="button" onClick={ver} disabled={!pronto} className="h-8 inline-flex items-center gap-1 rounded-md bg-purple-600 hover:bg-purple-700 disabled:opacity-60 text-white px-3 text-xs font-semibold" data-testid={`${testid}-ver`}>
          <Search className="w-3 h-3" /> Ver planos
        </button>
      </div>
      {alvo && <PlanosClaro uf={alvo.uf} cidade={alvo.cidade} servicos={null} tipoCliente={tipoCliente} credito={credito} escolherCredito={escolherCredito} onEscolherPlano={onEscolherPlano} compacto={compacto} testid={`${testid}-planos`} />}
      {!alvo && <p className="text-xs text-gray-500" data-testid={`${testid}-dica`}>Sem CEP ou HP o catálogo mostra tudo o que a Claro vende na cidade — a disponibilidade real (cabo/fibra) depende do endereço.</p>}
    </div>
  );
};
